import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=fd2912e0&"
var script = {}
import style0 from "./MenuItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MenuItem.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/menus/common/MenuItem.vue
// module id = 2323
// module chunks = 1